import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { Permission } from 'src/app/models/principal/permission';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from 'src/app/models/constants';
import { TenantService } from 'src/app/services/api/tenant.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent  implements OnInit {

  Constants = Constants;

  tenant: string;
  hasMySandboxPermission: boolean;
  permissionsMap: { [key: string]: boolean };
  Permission = Permission;

  constructor(private authService: AuthService, public toastrService: CustomToastrService, private fb: FormBuilder, public router: Router, public tenantService: TenantService) {
    
  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
  }
}
